import { Directive, inject, input } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';

@Directive({
  selector: 'mat-calendar[appMultiselect]',
  standalone: false,
})
export class CalendarDirective {
  readonly selectedDates = input<Date[]>(undefined);
  readonly handleSelect =
    input<(date: Date, dateIndex: number, selectedDates: Date[]) => void>(undefined);
  constructor() {
    const calendar = inject<MatCalendar<Date>>(MatCalendar);

    calendar._dateSelected = (event) => {
      const date = event.value as Date;
      const index = this.selectedDates().findIndex((currDate) => {
        return currDate.getTime() === date.getTime();
      });
      if (index === -1) {
        this.selectedDates().push(date);
      } else {
        this.selectedDates().splice(index, 1);
      }
      this.handleSelect()(date, index, this.selectedDates());
      calendar.updateTodaysDate();
    };
  }
}
